<template>
  <el-card shadow="hover" class="chart-card">
    <base-echart :options="chartOption" height="273px" />
  </el-card>
</template>

<script>
import BaseEchart from './BaseEchart';
import * as echarts from 'echarts';

export default {
  name: 'FakeEfficiencyChart',
  components: { BaseEchart },
  props: {
    title: {
      type: Array,
      default: () => []
    },
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartOption: {},
      exportIcon: require('@/assets/images/kanban/endKanbanBoard/Export.svg')
    };
  },
  watch: {
    chartData: {
      handler() {
        this.updateChartOption();
      },
      deep: true
    }
  },
  created() {
    this.updateChartOption();
  },
  methods: {
    updateChartOption() {
      const data = this.chartData || [];

      // 当数据为空时，确保设置空数组（虽然 map 会自动返回空数组，但显式处理更清晰）
      const xAxisData = data.length > 0 ? data.map((item) => item.dt) : [];
      const fakeSignCntData = data.length > 0
        ? data.map((item) => (item.fakeSignCnt))
        : [];
      const fakeSignRateData = data.length > 0
        ? data.map((item) => (item.fakeSignRate))
        : [];
      // 计算默认显示5条数据的结束百分比
      const defaultShowCount = 5;
      const showScrollBar = data.length > 6; // 超过6条才显示滚动条
      // 6条及以下全部显示，超过6条才显示前5条
      const endPercent = data.length <= 6
        ? 100
        : Math.min(100, (defaultShowCount / data.length) * 100);

      this.chartOption = {
        color: ['#2AAB80', '#4581DE', '#eb7e46'],
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let result = params[0].axisValueLabel + '<br/>';
            params.forEach((param) => {
              if (param.seriesIndex === 0) {
                result += param.marker + param.seriesName + ': ' + param.value + '<br/>';
              } else {
                const count = (param.value * 100).toFixed(2);
                result += param.marker + param.seriesName + ': ' + count + '%<br/>';
              }
            });
            return result;
          }
        },
        legend: {
          data: this.title,
          top: 0,
          icon: 'circle'
        },
        grid: { left: '3%', right: '4%', bottom: showScrollBar ? '15%' : '3%', containLabel: true },
        dataZoom: [
          {
            type: 'slider',
            show: showScrollBar,
            xAxisIndex: [0],
            start: 0,
            end: endPercent,
            height: 20,
            bottom: 5,
            borderColor: '#ccc',
            fillerColor: 'rgba(42, 171, 128, 0.2)',
            handleStyle: {
              color: '#2AAB80'
            }
          }
        ],
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLine: { lineStyle: { color: '#D9D9D9', type: 'dashed' }},
          axisTick: { show: false },
          axisLabel: { color: '#666' }
        },
        yAxis: {
          type: 'value',
          axisTick: { show: false },
          splitLine: { show: true, lineStyle: { type: 'dashed', color: '#E0E6F1' }},
          axisLabel: {
            show: false
            // formatter: (value) => {
            //   return (value * 100).toFixed(0) + '%';
            // }
          }
        },
        series: [
          {
            name: this.title[0],
            type: 'line',
            data: fakeSignCntData,
            smooth: true,
            showSymbol: true,
            areaStyle: {
              opacity: 0.5,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(42, 171, 128, 0.5)' },
                { offset: 1, color: 'rgba(255, 255, 255, 0)' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}'
            }
          },
          {
            name: this.title[1],
            type: 'line',
            data: fakeSignRateData,
            smooth: true,
            showSymbol: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#4581DE' },
                { offset: 1, color: 'rgba(255, 255, 255, 0)' }
              ])
            },
            label: {
              show: true,
              position: 'center',
              formatter: (value) => {
                return (value.value * 100).toFixed(2) + '%';
              }
            }
          }
        ]
      };
    }
  }
};
</script>

<style scoped lang="scss">
.chart-card {
  margin-bottom: 0;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: none;

  ::v-deep .el-card__header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
    font-size: 16px;
    color: #0f1728;
    font-style: normal;
    text-transform: none;
    font-weight: bold;
    .export-btn {
      width: 16px;
      height: 16px;
      cursor: pointer;
      transition: opacity 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
